export default Object.freeze({
  Trial: 0,
  Partner: 1,
  Basic: 2,
  Business: 3,
  Corporate: 4,
  Custom: 5,
});
